export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-zoom/src/constant.js
// module id = 472
// module chunks = 0